import { render, staticRenderFns } from "./Cambio_Precio.vue?vue&type=template&id=4a42863e"
import script from "./Cambio_Precio.vue?vue&type=script&lang=js"
export * from "./Cambio_Precio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports